import { Link } from 'react-router-dom';
import './Footer.css';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="footer">
            <p className="footerTagline">
                Admire the possibilities.
            </p>

            <div className="footerGrid">
                <div className="footerSection">
                    <p className="footerSectionTitle">Context</p>
                    <Link to="/about" className="footerLink">About</Link>
                    <Link to="/contact" className="footerLink">Contact</Link>
                    <Link to="/privacy" className="footerLink">Privacy</Link>
                </div>

                <div className="footerSection">
                    <p className="footerSectionTitle">Site</p>
                    <Link to="/" className="footerLink">Index</Link>
                    <Link to="/store" className="footerLink">Store</Link>
                    <Link to="/resource" className="footerLink">Resource</Link>
                    <Link to="/blog" className="footerLink">Blog</Link>
                </div>

                <div className='footerSection'>
                    <p className="footerSectionTitle">Link</p>
                    <div className="footerSocial">

                        <a href="https://www.facebook.com/explorelrt">
                            <FaFacebook className="facebookIcon" />
                            
                        </a>
                        <a href="https://www.instagram.com/explorelrt">
                            <FaInstagram className="instagramIcon" />
                            
                        </a>
                        <a href="https://www.linkedin.com/company/explorelrt">
                            <FaLinkedin className="linkedinIcon" />
                        </a>
                    
                    </div>
                </div>
            </div>

            <p className="footerCopyright">&copy; 2026 Explorelrt. All rights reserved.</p>


        </footer>
    );
}

export default Footer;
